import { createContext, useContext } from 'react'

export type BlueprintTrigger = {
  type: 'initial' | 'activity_changed'
  activityModelUuid?: string
  parentPath?: string[]
}

type BlueprintsContextType = {
  isFetchingBlueprints?: boolean
  executeBlueprints: (trigger?: BlueprintTrigger) => void
}

export const BlueprintsContext = createContext<BlueprintsContextType>({
  isFetchingBlueprints: false,
  executeBlueprints: () => {}
})

export default function useBlueprintsContext() {
  return useContext(BlueprintsContext)
}
